import { Cell, FormControl, Row } from '@dexma/ui-components';
import { StyledRowActivableInput, StyledWidgetTextFooterInput, StyledWidgetTextInput } from 'adapter/in/common/components/Text/style';
import PresetFormFieldProperties from 'domain/entity/preset/form/presetFormFieldProperties';
import React, { FormEvent, memo } from 'react';

export type FooterInputTextType = {
    text: string;
};

export const FooterInputText = memo((props: FooterInputTextType) => {
    const { text } = props;

    return <StyledWidgetTextFooterInput dangerouslySetInnerHTML={{ __html: text }} />;
});

const generateNumRowsTextarea = (maxLength: number) => {
    if (maxLength <= 500) return 4;
    if (maxLength <= 1000) return 6;
    return 8;
};

export type WidgetTextType = {
    control: 'Input' | 'Textarea';
    error: boolean;
    errorMessage?: string;
    label: string;
    name: string;
    dataTestId: string;
    footer: string;
    isLoading?: boolean;
    properties?: PresetFormFieldProperties;
    onChange: (text: string) => void;
    value: string;
};
const FormInputText = memo((props: WidgetTextType) => {
    const { control, label, error, errorMessage, name, footer, isLoading, properties, dataTestId, onChange, value } = props;
    const placeholder = properties?.placeholder ? properties.placeholder : undefined;
    const maxLength = properties?.maxLength ? properties.maxLength : undefined;

    const handleChange = (event: FormEvent<HTMLInputElement>) => {
        onChange(event.currentTarget.value);
    };

    return (
        <StyledWidgetTextInput $error={error}>
            <Row>
                <Cell className='widget-type-block'>
                    <span>{label}</span>
                </Cell>
            </Row>
            <StyledRowActivableInput>
                <Cell>
                    {isLoading !== undefined && control === 'Input' ? (
                        <FormControl
                            name={name}
                            control={control}
                            placeholder={placeholder}
                            maxLength={maxLength}
                            onChange={handleChange}
                            isLoading={isLoading}
                            data-testid={dataTestId}
                            value={value}
                        />
                    ) : (
                        <FormControl
                            name={name}
                            control={control}
                            placeholder={placeholder}
                            maxLength={maxLength}
                            onChange={handleChange}
                            data-testid={dataTestId}
                            value={value}
                            rows={maxLength && generateNumRowsTextarea(maxLength)}
                        />
                    )}
                    {error && <div className='error'>{errorMessage}</div>}
                </Cell>
            </StyledRowActivableInput>
            {footer && <FooterInputText text={footer} />}
        </StyledWidgetTextInput>
    );
});

export default FormInputText;
